import React, {useCallback, useRef} from "react";
import {showToast} from "common";

export const usePreSubmitValidation = () => {
    const isSubmittingRef = useRef(false);

    const validateBeforeSubmit = useCallback(async (validateFn, onSuccess) => {
        // Prevent double submissions
        if (isSubmittingRef.current) {
            return false;
        }
        isSubmittingRef.current = true;

        try {
            const { status, message } = await validateFn();
            if (!status) {
                showToast.warning(message, { duration: 15 });
                return false;
            }
            await onSuccess();
            return true;
        } finally {
            isSubmittingRef.current = false;
        }
    }, []);
    return { validateBeforeSubmit };
};
